export default "__VITE_ASSET__B$4WWN7v__"